import { Container, Row, Col, Card } from "react-bootstrap";
import { FaHandshake } from "react-icons/fa";
import about1 from "../../assets/image/about.png";
import about2 from "../../assets/image/features/4.png";

const About = () => {
  return (
    <Container className="my-4">
      <Row className="justify-content-center text-center">
        <Col md={10} lg={8}>
          <h2
            className="mb-4 text-primary fw-bold"
            style={{ fontSize: "40px" }}
          >
            Collaboration at <span className="text-success">TMS</span>
          </h2>
          <Card className="p-4 shadow border-0 bg-light">
            <p className="lead text-muted fw-bold">
              <FaHandshake className="text-success me-2" /> Innovating Together
              -{" "}
              <span className="text-dark">
                At TMS, collaboration fuels innovation. By working together, we
                create groundbreaking solutions that drive success.
              </span>
            </p>
          </Card>
        </Col>
      </Row>

      <Row className="align-items-center my-5">
        <Col md={6}>
          <img
            src={about1}
            alt="Collaboration"
            className="img-fluid rounded shadow-lg"
          />
        </Col>
        <Col md={6}>
          <Card
            className="shadow-lg border-0 p-4"
            style={{ backgroundColor: "#e3f2fd" }}
          >
            <Card.Body>
              <h4 className="text-primary fw-bold">Strategic Partnerships</h4>
              <p>
                Our expert team at TMS connects you with the right partners to
                unlock new opportunities and maximize growth potential.
              </p>
              <h4 className="text-success fw-bold">
                Cross-Industry Innovation
              </h4>
              <p>
                By leveraging each other’s strengths, we build a foundation for
                long-term success, tailoring solutions for evolving market
                needs.
              </p>
              <h4 className="text-warning fw-bold">Tech-Driven Solutions</h4>
              <p>
                From marketing strategies to technological advancements, TMS
                ensures that collaboration leads to tangible and measurable
                results.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="align-items-center my-5">
        <Col md={6}>
          <Card
            className="shadow-lg border-0 p-4"
            style={{ backgroundColor: "#f3e5f5" }}
          >
            <Card.Body>
              <h4 className="text-info fw-bold">Why Choose Fieldsathi?</h4>
              <p>
                Fieldsathi.com is a comprehensive CRM and Ticket Management
                System designed to streamline field operations, improve agent
                productivity, and enhance team management.
              </p>
              <h4 className="text-danger fw-bold">
                Efficient Service Management
              </h4>
              <p>
                Our system efficiently handles service requests, repairs,
                inspections, and installations, ensuring timely ticket creation
                and scheduling.
              </p>
              <h4 className="text-secondary fw-bold">Seamless Scheduling</h4>
              <p>
                Assign field technicians effortlessly and ensure smooth
                appointment management for all service requests.
              </p>
              <h4 className="text-success fw-bold">Customer Satisfaction</h4>
              <p>
                With real-time tracking and analytics, businesses can enhance
                workflow, optimize customer interactions, and deliver top-notch
                services.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <img
            src={about2}
            alt="Innovation"
            className="img-fluid rounded shadow-lg"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default About;
